module.exports = __webpack_public_path__ + "media/images/proposal/hall-list/proposal-halllist-5-44c41fdda07eed2414e14181aa10d97d.png";